import { AlertTriangle, Phone, ExternalLink } from 'lucide-react';

export const DisclaimerFooter = () => {
  return (
    <footer className="mt-auto border-t border-border bg-muted/30" data-testid="disclaimer-footer">
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Warning Banner */}
        <div className="flex items-center justify-center gap-2 mb-4 p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg">
          <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0" />
          <p className="text-xs text-amber-600 dark:text-amber-400 font-medium text-center">
            FOR ENTERTAINMENT PURPOSES ONLY • NOT FINANCIAL ADVICE • GAMBLE RESPONSIBLY
          </p>
        </div>

        {/* Disclaimer Text */}
        <div className="text-center space-y-3">
          <p className="text-xs text-muted-foreground leading-relaxed max-w-4xl mx-auto">
            <strong>DISCLAIMER:</strong> This website provides information for entertainment purposes only. 
            All lottery data is compiled from publicly available sources and may not be accurate or current. 
            We make no guarantees about the accuracy, completeness, or reliability of any information. 
            Any decision to purchase lottery tickets is made entirely at your own risk. 
            We are not responsible for any financial losses incurred.
          </p>

          <p className="text-xs text-muted-foreground">
            <strong>NOT AFFILIATED</strong> with the Washington State Lottery or any official lottery organization.
          </p>

          {/* Problem Gambling Resources */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Phone className="w-3 h-3" />
              <span>Problem Gambling? Call <strong className="text-accent">1-800-522-4700</strong></span>
            </div>
            <a 
              href="https://www.ncpgambling.org" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-xs text-accent hover:underline"
            >
              National Council on Problem Gambling
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>

          {/* Legal Footer */}
          <div className="pt-4 border-t border-border/50 mt-4">
            <p className="text-[10px] text-muted-foreground/70">
              © {new Date().getFullYear()} Scratch Ticket Advisor. All Rights Reserved. 
              Must be 18+ to play. Please play responsibly. 
              Lottery games are games of chance with no guaranteed outcome.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DisclaimerFooter;
